<template>
    <div class="boxbgcolor api-configure">
      <!--左侧树形展示所有停车场-->
      <div class="left content-left">
        <AllTree v-on:handleTreeClick="handleTreeClick"></AllTree>
      </div>
      <div class="right content-right configure-right">
        <el-form ref="addOrEditForm" label-width="150px" :rules="rules" :model="payConfigure">
          <el-form-item label="商户号" prop="mchId">
            <el-input v-model="payConfigure.mchId" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="商户私钥" prop="mchPrivate">
            <el-input v-model="payConfigure.mchPrivate" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
          <el-form-item label="平台公钥" prop="platformPublic">
            <el-input v-model="payConfigure.platformPublic" @focus="isParkingIdEmpty"></el-input>
          </el-form-item>
         
          <el-form-item>
            <el-checkbox v-model="payConfigure.openFlag" label="是否启用" name></el-checkbox>
          </el-form-item>
        </el-form>
        <div class="submit">
          <el-button type="primary" size="medium" @click="addOrEdit">提交</el-button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState, mapMutations } from "vuex";
  
  import { queryRcbConfig,updateRcbConfig } from "@/api/url";
  
  import AllTree from "@/page/commons/allTree";
  
  export default {
    name:'boc-configure',
    data() {
      return {
        treeData: {
          parkingId: "",
        },
        fileList: [],
        payConfigure: {
          id: "",
          mchId: "",
          mchPrivate: "",
          platformPublic: "",
       
          openFlag: false,
          parkingId: "",
        },
        rules: {
            mchId: [{ required: true, message: "请填写商户号", trigger: "blur" }],
            mchPrivate: [
            { required: true, message: "请填写商户私钥", trigger: "blur" },
          ],
          platformPublic: [
            { required: true, message: "请填写台公钥", trigger: "blur" },
          ],
       
          // openFlag: [
          //     { required: true, message: '请填写微信公众号名称', trigger: 'blur' }
          // ]
        },
      };
    },
    methods: {
      ...mapMutations(["getPage"]),
      //点击树的节点展示相应数据
      handleTreeClick: function (node, data) {
        this.resetForm();
        if (node.type == "parking") {
          this.treeData.parkingId = node.id;
          this.payConfigureOne();
        } else {
          this.treeData.parkingId = "";
          this.payConfigure.mchId = "";
          this.payConfigure.mchPrivate = "";
          this.payConfigure.platformPublic = "";
        
          this.payConfigure.openFlag = false;
          // this.$message({
          //         message: '请选择车场！',
          //         type: 'warning'
          // });
        }
        // if(node.level==2){
        // 	this.treeData.parkingId=data.parent.data.id;
        // 	this.treeData.areaId=node.id;
        // }
      },
      payConfigureOne() {
        this.$postRequest(queryRcbConfig(), {
          parkingId: this.treeData.parkingId,
        }).then((data) => {
          if (data.data) {
            // this.treeData.parkingId=data.data.parkingId;
            this.payConfigure.mchId = data.data.mchId;
            this.payConfigure.id = data.data.id;
            this.payConfigure.mchPrivate = data.data.mchPrivate;
            this.payConfigure.platformPublic = data.data.platformPublic;
         
            this.payConfigure.openFlag = data.data.openFlag == "y" ? true : false;
          } else {
            // this.treeData.parkingId='';
            this.payConfigure.mchId = "";
            this.payConfigure.id = "";
            this.payConfigure.mchPrivate = "";
            this.payConfigure.platformPublic = "";
         
            this.payConfigure.openFlag = false;
          }
        });
        // console.log(this.payConfigure.openflag)
      },
      addOrEdit() {
        if (!this.treeData.parkingId) {
          this.$message({
            message: "请选择车场！",
            type: "warning",
          });
          return;
        }
        this.$refs.addOrEditForm.validate((valid) => {
          if (valid) {
            if (this.payConfigure.id) {
              this.$postRequest(updateRcbConfig(), {
                id: this.payConfigure.id,
                parkingId: this.treeData.parkingId, //停车场ID
                mchId: this.payConfigure.mchId,
                mchPrivate: this.payConfigure.mchPrivate,
                platformPublic: this.payConfigure.platformPublic,
              
                openFlag: this.payConfigure.openFlag ? "y" : "n",
              }).then((data) => {
                //提交后的操作
                if (data.status != 200) return this.$layer.msg(data.message);
                this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改配置成功!",
                });
              });
            } else {
              this.$postRequest(updateRcbConfig(), {
                parkingId: this.treeData.parkingId, //停车场ID
                mchId: this.payConfigure.mchId,
                mchPrivate: this.payConfigure.mchPrivate,
                platformPublic: this.payConfigure.platformPublic,
                openFlag: this.payConfigure.openFlag ? "y" : "n",
              }).then((data) => {
                if (data.status != 200) return this.$layer.msg(data.message);
                this.$notify({
                  type: "success",
                  title: "成功",
                  message: "新增配置成功!",
                });
              });
            }
          } else {
          }
        });
      },
      isParkingIdEmpty() {
        if (!this.treeData.parkingId) {
          this.$message({
            message: "请选择车场！",
            type: "warning",
          });
        }
      },
      resetForm() {
        this.$refs["addOrEditForm"].resetFields();
      },
    },
    computed: {},
    components: {
      AllTree,
    },
  
    mounted: function () {},
  };
  </script>
  
  <style scoped>
  .submit {
    text-align: center;
  }
  </style>
  <style>
  .api-configure .el-form {
    width: 70%;
    margin: 0 auto;
    margin-top: 50px;
  }
  .api-configure .content-right .el-input__inner {
    border-radius: 5px;
    height: 50px;
    line-height: 50px;
  }
  .api-configure .el-form-item {
    margin-bottom: 30px;
  }
  .api-configure .el-form-item__label {
    height: 50px;
    line-height: 50px;
    color: #333 !important;
    font-weight: bold;
  }
  .submit .el-button {
    width: 200px;
    height: 50px;
  }
  .api-configure .el-checkbox__label {
    color: #333 !important;
    font-weight: bold;
  }
  </style>